import { Flex, Skeleton, SkeletonGroup } from '@acsbe/ui';
import { useTranslation } from 'react-i18next';

export const StripeLoader = () => {
  const { t } = useTranslation();

  return (
    <SkeletonGroup label={t('LOADING')}>
      <Flex gap={3}>
        <Flex gap={2.5}>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="456px" height="40px" />
        </Flex>
        <Flex gap={2.5}>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="456px" height="40px" />
        </Flex>
        <Flex gap={2.5}>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="456px" height="40px" />
        </Flex>
        <Flex gap={2.5}>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="456px" height="40px" />
        </Flex>
        <Flex gap={2.5} marginBlockStart={8}>
          <Skeleton width="100%" height="40px" />
        </Flex>
      </Flex>
    </SkeletonGroup>
  );
};
